export default function PageTitle({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <h1
      className={`font-medium text-2xl leading-9 text-left text-secondary ${className || ""}`}
    >
      {children}
    </h1>
  );
}
